// extracted by mini-css-extract-plugin
var _1 = "T0hOuqkA";
var _2 = "d0tWcmxd";
var _3 = "G0lTaAR5";
var _4 = "scR9j7Kb";
export { _1 as "active", _2 as "background", _3 as "container", _4 as "timer" }
